import { formatDate } from "utils/basic";

import {
  RESTRICTION_LABELS,
  RestrictionType,
  StatusRestriction,
} from "./data/types";

export const getRestrictionByType = (
  restrictions: StatusRestriction[],
  type: RestrictionType,
): StatusRestriction | undefined => restrictions.find((r) => r.type === type);

export const hasRestriction = (
  restrictions: StatusRestriction[],
  type: RestrictionType,
): boolean => restrictions.some((r) => r.type === type);

export const isSeverelyRestricted = (
  restrictions: StatusRestriction[],
): boolean => {
  const activeTypes = new Set(restrictions.map((r) => r.type));

  return (
    activeTypes.has("block") ||
    (activeTypes.has("ban_edit") && activeTypes.has("ban_publish"))
  );
};

export const getRestrictionErrorMessage = (data: any): string | null => {
  if (data?.error !== "restriction") return null;

  const label = RESTRICTION_LABELS[data.type as RestrictionType] || data.type;
  const expiry = data.expiresAt
    ? `до ${formatDate(data.expiresAt)}`
    : "бессрочно";

  return `${label}${data.reason ? `: ${data.reason}` : ""} (${expiry})`;
};
